import { Navigate, Outlet } from "react-router-dom";
import cookie from 'js-cookie';

function ProtectedRoute() {
  const isAuthenticated = cookie.get('ajwt');
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
}

export default ProtectedRoute;